export default{
  shipping_method: 'Méthode d\'envoi',
  shipping_time: 'Temps d\'expédition',
  costs: 'Frais',
  shipping_to: 'Expédition à'
}


// WEBPACK FOOTER //
// ./src/i18n/fr.js